import { useEffect } from "react"

export const useTimeout = (callback, delay = 3000, dependencies = []) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      callback()
    }, delay)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [delay, ...dependencies])
}



// WEBPACK FOOTER //
// ./src/hooks/useTimeout.js